import React from 'react';
import { FormSection, autofill, Field } from 'redux-form';
import _ from 'lodash';
import PayjpCheckout from 'jbc-front/components/PayjpCheckout';
import { connect } from 'react-redux';
import { CURRENT_CLIENT_FORM } from 'src/constants/FormNames';

import { RadioField, CheckboxField, Section, TextField, BoxDouble, Error } from 'jbc-front/components/Form';
import Button from 'jbc-front/components/Button';
import CreditCardInfo from 'jbc-front/components/CreditCardInfo';
import { InitialSettingLogo } from 'jbc-front/components/icons';
import { FormErrors, TelField, Address } from 'src/components';
import { isEmail, isRequired } from 'src/utils/CustomValidators';
import { setGlobalErrors } from 'src/reducers/global';
import styles from '../EditClientPaidPlan.scss';

export const paymentMethodTypes = [
  { label: '請求書払い(銀行・コンビニ)', value: 'bill' },
  { label: 'クレジットカード支払い', value: 'credit_card' }
];

export const CardInput = connect()(({ dispatch, disabled, formName, cardToken }) => (
  <div className={disabled ? `${styles.disablePointer} u-mb20` : 'u-mb20'}>
    <PayjpCheckout
      apiKey={process.env.PAYJP_KEY}
      submitText="カード情報を入力する"
      text="カード情報を入力する"
      onCreated={({ id, card }) => {
        dispatch(autofill(formName, 'creditInfo.cardToken', id));
        dispatch(autofill(formName, 'creditInfo._cardInfo', card));
      }}
      onFailed={(errorCode, errorResponse) => {
        dispatch(setGlobalErrors(_.get(errorResponse, 'message') || `エラーが発生しました(code: ${errorCode})`));
      }}
      previousToken={cardToken}
    />
    <Field name="cardToken" validate={isRequired} label="カード情報" component={Error} />
  </div>
));

const UpdateToPaidPlanForm = ({
  handleSubmit,
  submitting,
  errors,
  confirming,
  paymentMethodType,
  firstBillSend,
  cardInfo,
  cardToken,
  changeEditable,
  pristine
}) => (
  <form onSubmit={handleSubmit}>
    <div className="l-wrap-xs">
      <FormErrors errors={errors} />
      <Section title="初期設定プラン（有償オプション）について">
        <InitialSettingLogo width={218} height={25} />
        <p className={styles.serviceDescription}>
          ジョブカン初期設定プランでは、各ジョブカンサービスの初期設定の代行を行います。
        </p>
        <div className={styles.checkBoxField}>
          <CheckboxField
            name="interestedInInitialSettingPlan"
            disabled={confirming}
            label="ジョブカン初期設定プランへの興味"
            labelContent={
              <span className={styles.checkboxLabel}>
                <span className={styles.serviceName}>初期設定プラン</span> に興味がある
              </span>
            }
          />
        </div>
        <p className={styles.serviceAttention}>
          ※こちらは初期設定プランのお申込みではございません。<br />　チェックを入れた場合、担当者より詳細についてご連絡させていただきます。
        </p>
        <div className={styles.serviceDetailBox}>
          <ul className={styles.serviceDetailContent}>
            <li>給与計算の設定内容</li>
            <li>
              ・事業所情報の登録<br />
              ・社会保障の設定<br />
              ・勤怠項目の設定
            </li>
            <li>
              ・給与規定の設定<br />
              ・従業員の設定<br />
              etc...
            </li>
          </ul>
        </div>
        <div className={styles.serviceDetailLink}>
          <a href="https://payrollth.jobcan.in.th/flow/#a-initial" target="_blank" rel="noopener noreferrer">
            詳しくはこちら
          </a>
        </div>
      </Section>
      <Section title="決済方法">
        <RadioField name="paymentMethodType" options={paymentMethodTypes} disabled={confirming} />
        {paymentMethodType === 'bill' && (
          <React.Fragment>
            <dl className={styles.field}>
              <dt>請求書払い：</dt>
              <dd>（銀行・コンビニ）</dd>
            </dl>
            <dl className={styles.field}>
              <dt>請求書発行元：</dt>
              <dd>株式会社ネットプロテクションズ</dd>
            </dl>
            <dl className={styles.field}>
              <dt>初回請求書送付日：</dt>
              <dd>{firstBillSend.format('YYYY年MM月')}上旬</dd>
            </dl>
            <dl className={styles.field}>
              <dt>初回振込期限：</dt>
              <dd>{firstBillSend.format('YYYY年MM月')}月末（※振込期限日は請求書をご確認ください）</dd>
            </dl>
          </React.Fragment>
        )}
        <ul className={`${styles.notes} u-mt20`}>
          <li>※ 月額ご利用金額が¥2,000以下の場合、最低利用金額(¥2,000)をご請求いたします。</li>
          {paymentMethodType === 'bill' && <li>※ 申込後、クレジットカード払いに変更できます。</li>}
          <li>※ 価格はすべて税抜きです。</li>
        </ul>
      </Section>
      <Section title="請求先情報の入力">
        {paymentMethodType === 'bill' ? (
          <FormSection name="billInfo">
            <TextField name="name" label="事業所名" disabled={confirming} required maxLength="255" />
            <TextField name="group" label="部署名" disabled={confirming} />
            <BoxDouble>
              <TextField name="employeeLastName" label="担当者姓" disabled={confirming} required maxLength="32" />
              <TextField name="employeeFirstName" label="担当者名" disabled={confirming} required maxLength="32" />
            </BoxDouble>

            <Address required withKana={false} postCodeRequired disabled={confirming} />
            <TelField required disabled={confirming} />

            <TextField
              name="employeeEmail"
              label="メールアドレス"
              validate={isEmail}
              disabled={confirming}
              required
              maxLength="255"
            />
          </FormSection>
        ) : (
          paymentMethodType === 'credit_card' && (
            <FormSection name="creditInfo">
              <CardInput formName={CURRENT_CLIENT_FORM} disabled={confirming} cardToken={cardToken} />
              {cardInfo && (
                <div>
                  <div>カード情報</div>
                  <CreditCardInfo cardInfo={cardInfo} className={styles.cardInfo} />
                </div>
              )}
              <TextField
                name="employeeEmail"
                label="メールアドレス"
                validate={isEmail}
                required
                disabled={confirming}
              />
            </FormSection>
          )
        )}
        <CheckboxField
          name="agreeToTOS"
          label="ジョブカン基本規約・ジョブカン給与計算利用規約・利用規約・プライバシーポリシー・個人情報の取り扱い"
          labelContent={
            <span>
              &nbsp;<a
                className="u-txt-link"
                href="https://all.jobcan.ne.jp/terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                ジョブカン基本規約
              </a>および
              <a
                className="u-txt-link"
                href="https://payrollth.jobcan.in.th/terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                ジョブカン給与計算利用規約
              </a>、
              <a
                className="u-txt-link"
                href="https://all.jobcan.ne.jp/policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                プライバシーポリシー
              </a>、
              <a
                className="u-txt-link"
                href="https://all.jobcan.ne.jp/personalinfo/"
                target="_blank"
                rel="noopener noreferrer"
              >
                個人情報の取り扱い
              </a>に同意します
            </span>
          }
        />
        <div className="u-ta-c u-mt30">
          {confirming && (
            <Button
              disabled={submitting}
              onClick={() => {
                changeEditable(true);
              }}
              className="u-mr20"
            >
              修正する
            </Button>
          )}
          <Button primary onClick={handleSubmit} disabled={submitting || pristine}>
            {confirming ? '申し込む' : '確認'}
          </Button>
        </div>
      </Section>
    </div>
  </form>
);

export default UpdateToPaidPlanForm;
